<template>
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M25.1654 3H6.83269C4.72471 3 3 4.72471 3 6.83269V25.1673C3 27.2753 4.72471 29 6.83269 29H25.1673C27.2753 29 29 27.2753 29 25.1673V6.83269C28.9981 4.72471 27.2753 3 25.1654 3ZM24.9191 16.8772H21.8338V28.0399H17.2174V16.8772H14.9082V13.0292H17.2174V10.72C17.2174 7.58102 18.5205 5.71354 22.2286 5.71354H25.311V9.5606H23.3832C21.9421 9.5606 21.8463 10.1001 21.8463 11.1033L21.8338 13.0292H25.3264L24.9191 16.8772Z"
            fill="currentColor"
        />
    </svg>
</template>
